import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useMemo } from 'react';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { getCianMortgagePromoUrl } from 'shared/utils/motgageCalculator/getCianMortgagePromoUrl';
import { getPromoModalConfig } from 'shared/utils/motgageCalculator/getPromoModalConfig';

export const usePromoDetailsConfig = (): IPromoModalProps['config'] => {
  const { config } = useApplicationContext();
  const mortgagePartnerLink = getCianMortgagePromoUrl(config);
  const promoModalConfigRs = getPromoModalConfig(config);

  return useMemo(() => {
    return {
      listingBaseUrlDesktop: promoModalConfigRs?.listingBaseUrlDesktop,
      listingBaseUrlMobile: promoModalConfigRs?.listingBaseUrlMobile,
      fullCreditPriceModalText: promoModalConfigRs?.fullCreditPriceModalText,
      mortgagePartnerLink,
    };
  }, [promoModalConfigRs, mortgagePartnerLink]);
};
